import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

export default wordboard => Vue.$http
    .delete(`Wordboards/${encodePathSegment(wordboard.id)}`);



// WEBPACK FOOTER //
// ./src/services/wordboard/del.js